module.exports = __webpack_public_path__ + "socicon.60e5857089e98edd8380.eot";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/socicon/font/socicon.eot
// module id = ../../../../socicon/font/socicon.eot
// module chunks = styles